

<template>
  <!-- Checkout Page Area Start -->
  <section class="checkout-page-area">
    <div class="container">
      <div class="row">
        <div class="col-lg-8">
          <div class="checkout-left-box">
            <h3>Billing Details</h3>
            <form>
              <div class="row checkout-form">
                <div class="col-md-6">
                  <input placeholder="Your First Name" type="text" name="firstname" id="name23">
                </div>
                <div class="col-md-6">
                  <input placeholder="Your Last Name" type="text" name="lastname" id="name22">
                </div>
              </div>
              <div class="row checkout-form">
                <div class="col-md-12">
                  <input placeholder="Country" type="text" name="country" id="cntr2">
                </div>
              </div>
              <div class="row checkout-form">
                <div class="col-md-12">
                  <input placeholder="Your Address" type="text" name="address" id="addr2">
                </div>
              </div>
              <div class="row checkout-form">
                <div class="col-md-12">
                  <input placeholder="Town / City" type="text" name="town" id="Town2">
                </div>
              </div>
              <div class="row checkout-form">
                <div class="col-md-6">
                  <input placeholder="Your Email Address" type="email" name="info2" id="info2">
                </div>
                <div class="col-md-6">
                  <input placeholder="Your Mobile Number" type="text" name="info2" id="info12">
                </div>
              </div>
              <div class="row checkout-form">
                <div class="col-md-12">
                  <textarea placeholder="Write Order Note Here..." name="ordernote"></textarea>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="order-summury-box">
            <h3>Order Summury</h3>
            <div class="summury-inn">
              <table>
                <tbody>
                <tr>
                  <td>Cart Subtotal</td>
                  <td>£{{cartTotal}}</td>
                </tr>
                <tr>
                  <td>Shipping and Handling</td>
                  <td>Free Shipping</td>
                </tr>
                <tr>
                  <td>Order Total</td>
                  <td>£{{cartTotal}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="booking-right">
            <div class="checkout-payment clearfix">
              <div class="payment">
                <input type="radio" id="ss-option" name="selector">
                <label for="ss-option">Direct Bank Transfer</label>
                <div class="check">
                  <div class="inside"></div>
                </div>
                <p>Make your payment directly into our bank account. Please use your Order ID as the payment reference.order won’t be shipped until the funds have cleared.</p>
              </div>
              <div class="payment">
                <input type="radio" id="f-option" name="selector">
                <label for="f-option">Cheque Payment</label>
                <div class="check">
                  <div class="inside"></div>
                </div>
              </div>
              <div class="payment">
                <input type="radio" id="s-option" name="selector">
                <label for="s-option">Credit Card</label>
                <div class="check">
                  <div class="inside"></div>
                </div>
                <img src="../../assets/img/master-card.jpg" alt="credit card">
              </div>
              <div class="payment">
                <input type="radio" id="t-option" name="selector">
                <label for="t-option">Paypal</label>
                <div class="check">
                  <div class="inside"></div>
                </div>
                <img src="../../assets/img/paypal.jpg" alt="credit card">
              </div>
            </div>
            <div class="action-btn">
              <a href="#" class="cta_btn">place order <span></span></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Checkout Page Area End -->
</template>
<script>
import {mapState} from 'vuex';
export default {
  name: 'CheckoutPageArea',
  computed: {
    ...mapState({
      cartItems: function (state) {
        return state.carts.items;
      }
    }),
    cartTotal: {
      get: function () {
        return Number(
          this.cartItems
            .reduce(function (subTotal, item) {
              return Number.parseFloat(
                subTotal + Number(item.total)
              );
            }, 0)
            .toFixed(2)
        );
      },
      set: function (newValue) {
        // console.log('carts: ', newValue);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/products/CheckoutPageArea.vue